var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import DataTable from '@/components/data-table/DataTable';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AsyncSelect from '@/components/async-select/AsyncSelect';
import { Group } from '@/models/Group';
import { GroupType, GroupTypeEnum } from '@/models/GroupType';
import { Student } from '@/models/Student';
import { avatarHtml } from '@/support/String';
import { Teacher } from '@/models/Teacher';
import ErrorHandler from '@/support/ErrorHandler';
let CreateDialog = class CreateDialog extends Vue {
    constructor() {
        super(...arguments);
        this.groupTypes = [];
        this.isLoading = true;
        this.currentStep = 1;
        this.group = new Group();
        this.teacherModel = new Teacher();
        this.teachers = [];
        this.selected = [];
        this.clearSelects = false;
        this.selectedStudents = [];
        this.selectedGroup = null;
        this.selectedSubGroups = [];
        this.TableHeader = [
            {
                text: 'Name',
                value: 'name',
            },
        ];
        this.type = null;
    }
    get tableOptions() {
        return {
            name: {
                singular: 'Student',
                plural: 'Students',
            },
            headers: [
                {
                    text: '',
                    value: 'avatar',
                    transform: avatarHtml,
                },
                { text: this.$t('name.title'), value: 'name' },
            ],
            actions: [],
            filters: [],
            model: new Student(),
        };
    }
    get subGroupTableOptions() {
        return {
            name: {
                singular: 'Group',
                plural: 'Groups',
            },
            headers: [
                { text: this.$t('name.title'), value: 'name' },
                {
                    text: this.$tc('group.type'),
                    value: 'type',
                    transform: (type, group) => type.name,
                },
            ],
            actions: [],
            filters: [],
            model: new Group().include('type').filter({ without_parent_groups: true }),
        };
    }
    mounted() {
        this.initialize();
    }
    async initialize() {
        await this.fetchGroupTypes();
    }
    async fetchGroupTypes() {
        try {
            this.isLoading = true;
            const types = await new GroupType().all();
            this.groupTypes = types.map((groupType) => {
                let translated = groupType.name;
                if (!translated) {
                    translated = Object.values(GroupTypeEnum).includes(groupType.label)
                        ? String(this.$t(`group.types.${groupType.label}`))
                        : groupType.label;
                }
                return {
                    ...groupType,
                    translated,
                };
            });
            // console.log(this.groupTypes[3].translated);
        }
        finally {
            this.isLoading = false;
        }
    }
    getGroupLabel() {
        if (!this.group || !this.group.type || typeof this.group.type === 'string') {
            return '-';
        }
        const groupType = this.group.type;
        let translated = groupType.name;
        if (!translated) {
            translated = Object.values(GroupTypeEnum).includes(groupType.label)
                ? String(this.$t(`group.types.${groupType.label}`))
                : groupType.label;
        }
        return translated;
    }
    close() {
        this.$emit('input', false);
        this.clearSelects = false;
        this.currentStep = 1;
    }
    currentStepChanged(currentStep, previousStep) {
        if (currentStep === 5) {
            this.create();
        }
    }
    create() {
        const users = [];
        this.teachers.forEach((teacher) => {
            users.push(teacher.value);
        });
        this.selectedStudents.forEach((student) => {
            users.push(student.id);
        });
        this.group.users = users;
        const subGroups = [];
        this.selectedSubGroups.forEach((subGroup) => {
            subGroups.push(subGroup.id);
        });
        this.group.sub_groups = subGroups;
        if (this.group.type && typeof this.group.type !== 'string') {
            this.group.type = this.group.type.id;
        }
        this.group
            .create()
            .then((group) => {
            this.$emit('groupCreated');
        })
            .catch((error) => {
            ErrorHandler.network(error);
            this.currentStep = 1;
        });
    }
    clear() {
        this.group = new Group();
        this.selectedStudents = [];
        this.clearSelects = true;
        this.$nextTick(() => {
            this.close();
        });
    }
    selectedItemsChange(value, oldValue) { }
};
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], CreateDialog.prototype, "preselectedStudents", void 0);
__decorate([
    Watch('currentStep'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, Number]),
    __metadata("design:returntype", void 0)
], CreateDialog.prototype, "currentStepChanged", null);
__decorate([
    Watch('selected'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array, Array]),
    __metadata("design:returntype", void 0)
], CreateDialog.prototype, "selectedItemsChange", null);
CreateDialog = __decorate([
    Component({
        components: {
            AsyncSelect,
            DataTable,
        },
    })
], CreateDialog);
export default CreateDialog;
class ExtendedGroupType extends GroupType {
}
